import "./layout.scss";
import "../landing/ln.scss";
import "./cabinet.scss";
import "../../components/ShowApplic/styles.scss";
import React, { useEffect } from "react";
import { Sidebar } from "../../components";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getprofilAsync } from "../../Redux/Reducers/Profil/profilSlice";
import LandingHead from "../landing/LandingHead/LandingHead";
import LandingFoot from "../landing/LandingFoot/LandingFoot";

export default function Layout() {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.open);
  useEffect(() => {
    if (localStorage.getItem("token")) {
      if (JSON.parse(localStorage.getItem("user"))?.legal_entity == null) {
        window.location.href = "/register/last-step";
      }
      dispatch(getprofilAsync("legal-entity/profile"));
    } else {
      window.location.href = "/login";
    }
  }, []);
  return (
    <div className={`${open.value} ln ln-cab`}>
      <LandingHead />
      <main className="ln-cab__main">
        <div className="ln-cab__wrap">
          <aside className="ln-cab__side">
            <Sidebar />
          </aside>
          <section className="ln-cab__content">
            <Outlet />
          </section>
        </div>
      </main>
      <LandingFoot />
    </div>
  );
}
